module.exports = __webpack_public_path__ + "img/匯巨_LOGO_320x150.29cf6938.png";